{
  "completed": "Tamamlanmış: ",
  "current": "Güncel: ",
  "notCompleted": "Tamamlanmamıs: ",
  "steplist": "Adım Listesi"
}
